<template>
  <b-form-group
    label="Menü Rengi"
    label-for="menu_color_mode"
  >
    <validation-provider
      #default="{ errors }"
      name="Menü Rengi"
      rules="required"
    >
      <v-select
        id="menu_color_mode"
        v-model="dataItem.menu_color_mode"
        label="title"
        :options="menuColors"
        :reduce="color => color.id"
        placeholder="Seçiniz"
        :disabled="userData.packageLimits[23].limit < 1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'MenuColorSelectConfigsCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      locale: 'tr',
      userData: JSON.parse(localStorage.getItem('userData')),
      menuColors: [
        {
          id: 'dark',
          title: 'Koyu Mod',
        },
        {
          id: 'light',
          title: 'Aydınlık Mod',
        },
      ],
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['configs/dataItem']
    },
  },
  created() {
    localize(this.locale)
  },
}
</script>

<style scoped></style>
